import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchCurrentCustomer } from "#/lib/auth-client";
import type { Customer, Session } from "#/lib/medusa-types/auth";
import { ANONYMOUS_SESSION } from "#/lib/medusa-types/auth";

export const sessionKeys = {
  all: ["storefront", "session"] as const,
  current: ["storefront", "session", "current"] as const,
};

export const sessionQueries = {
  current: () =>
    queryOptions<Session>({
      queryKey: sessionKeys.current,
      queryFn: async () => {
        const customer = await fetchCurrentCustomer();
        return { customer };
      },
      staleTime: 30_000,
    }),
};

export type UseSessionResult = {
  session: Session;
  customer: Customer | null;
  isAuthenticated: boolean;
  isPending: boolean;
};

export function useSession(): UseSessionResult {
  const { data, isPending } = useQuery(sessionQueries.current());
  const session = data ?? ANONYMOUS_SESSION;
  return {
    session,
    customer: session.customer,
    isAuthenticated: session.customer !== null,
    isPending,
  };
}
